import { dateToUTC } from "../pages/PaymentUpsert.page";
import { HandleError } from "./errorHandler.service";
import axios from "axios";

const url = process.env.REACT_APP_ADMIN_API_URL;
const smsKey = process.env.REACT_APP_SMS_KEY;

export const _login = async (data) => {
    const dataToSend = {
        "email": data.email,
        "password": data.password
    };
    return await _fetch('', dataToSend, '/login');
};

export const _resetPassword = async (email) => {
    const dataToSend = {
        "email": email
    };
    return await _fetch('', dataToSend, '/reset-password-request');
};

export const _setNewPassword = async (token, password) => {
    const dataToSend = {
        "password": password
    };
    return await _fetch(`token: ${token}`, dataToSend, '/reset-password');
};

export const _usersGet = async (token, filter) => {
    let _filter = Object.entries(filter).reduce((str, [p, val]) => {
        return `${str}${p}=${val}&`;
    }, '');
    _filter = `?${_filter}`;
    return await _get(`token: ${token}`, `/users${_filter}`);
};

export const _usersListGet = async (token, CustomPriceCreating = false) => {
    return await _get(`token: ${token}`, `/users-short${CustomPriceCreating ? '?exclude_with_prices=true' : ''}`);
};

export const _userHistoryGet = async (token, id) => {
    return _get(`token: ${token}`, `/users/${id}/history?page_size=10000`);
};

export const _userGet = async (token, id) => {
    return await _get(`token: ${token}`, `/users/${id}`);
};

export const _userSave = async (token, data, id) => {
    const dataToSend = {
        "first_name": data.first_name,
        "last_name": data.last_name,
        "new_password": data.password,
        "status": data.status
    };
    return await _fetch(`token: ${token}`, dataToSend, `/users/${id}`, true);
};

export const _userDelete = async (token, id) => {
    return await _delete(`token: ${token}`, `/users/${id}`);
};

export const _userChangeStatus = async (token, user, status) => {
    const dataToSend = {
        "first_name": user.first_name,
        "last_name": user.last_name,
        "status": status
    };
    return await _fetch(`token: ${token}`, dataToSend, `/users/${user.id}`, true);
};

export const _adminUsersGet = async (token, filter) => {
    let _filter = Object.entries(filter).reduce((str, [p, val]) => {
        return `${str}${p}=${val}&`;
    }, '');
    _filter = `?${_filter}`;
    return await _get(`token: ${token}`, `/admin-users${_filter}`);
};

export const _adminUserGetById = async (token, id) => {
    return await _get(`token: ${token}`, `/admin-users/${id}`);
};

export const _adminUserUpsert = async (token, data, id = '') => {
    const dataToSend = {
        "email": data.email,
        "first_name": data.first_name,
        "last_name": data.last_name,
        "password": data.password,
        "status": data.status
    };
    return await _fetch(`token: ${token}`, dataToSend, `/admin-users${id ? `/${id}` : ''}`, id);
};

export const _pricesGet = async (token, search) => {
    return await _get(`token: ${token}`, `/prices${search ? `?search=${search}` : ''}`);
};

export const _pricesUpload = async (token, data) => {
    return await _fetch(`token: ${token}`, data, `/prices`);
};

export const _tariffsGet = async (token) => {
    return await _get(`token: ${token}`, `/tariff-packages`);
};

export const _tariffPlanAdd = async (token, data) => {
    const dataToSend = {
        "name": data.name,
        "allowed_directions": data.destination.filter((e) => { return e }),
        "denied_destinations": data.deny_destination.filter((e) => { return e }),
        "start_date": data.start_date,
        "end_date": data.end_date,
        "cost": data.price.toString(),
        "validity_period": parseInt(data.validity_time),
        "sms_limit": parseInt(data.sms_limit),
        "description": data.description
    };
    return await _fetch(`token: ${token}`, dataToSend, `/tariff-packages`);
};

export const _tariffPlanEdit = async (data, id) => {

};

export const _tariffPlanDelete = async (token, id) => {
    return await _delete(`token: ${token}`, `/tariff-packages/${id}`);
};

export const _sendersGet = async (token, search) => {
    return await _get(`token: ${token}`, `/senders${search ? `?search=${search}` : ''}`);
};

export const _senderGetById = async (token,id) => {
    return await _get(`token: ${token}`, `/senders/${id}`);
};

export const _senderUpsert = async (token, data, id = '') => {
    const dataToSend = {
        "number": data.name
    };
    return await _fetch(`token: ${token}`, dataToSend, `/senders${id ? `/${id}` : ''}`, id);
};

export const _senderDelete = async (token, id) => {
    return await _delete(`token: ${token}`, `/senders/${id}`);
};

export const _paymentsGet = async (token, search) => {
    return await _get(`token: ${token}`, `/payments${search ? `?${search}` : ''}`);
};

export const _paymentGetById = async (token, id) => {
    return await _get(`token: ${token}`, `/payments/${id}`);
}

export const _paymentAdd = async (token, data) => {
    const dataToSend = {
        "user_id": data.email.value,
        "payment_date": data.payment_date,
        "amount": data.paid_amount.toString(),
        "details": data.description
    };
    return await _fetch(`token: ${token}`, dataToSend, `/payments`);
};

export const _paymentEdit = async (token, data, id) => {
    const dataToSend = {
        "user_id": data.email.value,
        "payment_date": dateToUTC(data.payment_date),
        "amount": data.paid_amount.toString(),
        "details": data.description
    };
    return await _fetch(`token: ${token}`, dataToSend, `/payments/${id}`, true);
};

export const _paymentDelete = async (token, id) => {
    return await _delete(`token: ${token}`, `/payments/${id}`);
};

export const _paymentHistoryGet = async (token, id) => {
    return await _get(`token: ${token}`, `/payments/${id}/history?page_size=10000`);
};

export const _tariffPlansGet = async (token, search) => {
    return await _get(`token: ${token}`, `/tariff-package-gifts${search ? `?${search}` : ''}`);
};

export const _tariffPlanCancel = async (token, id) => {
    return await _delete(`token: ${token}`, `/tariff-package-gifts/${id}`);
};

export const _tariffPlanAssign = async (token, data) => {
    const dataToSend = {
        "user_id": data.email.value,
        "tariff_package_id": data.tariff_package.value,
        "details": data.description
    };
    return await _fetch(`token: ${token}`, dataToSend, `/tariff-package-gifts`);
};

export const _tariffPackagesListGet = async (token) => {
    return await _get(`token: ${token}`, `/tariff-packages-short`);
};

export const _customPricesGet = async (token,search) => {
    return await _get(`token: ${token}`, `/prices/custom${search ? `?${search}` : ''}`);
};

export const _customPriceAdd = async (token, data) => {
    return await _fetch(`token: ${token}`, data, `/prices/custom`);
};

export const _customPriceGetById = async (token, id, search = '') => {
    return await _get(`token: ${token}`, `/prices/custom/${id}${search ? `?search=${search}` : ''}`);
};

export const _customPriceEdit = async (token, data, id) => {
    return await _fetch(`token: ${token}`, data, `/prices/custom/${id}`, true);
};

export const _customPriceDelete = async (token, id) => {
    return await _delete(`token: ${token}`, `/prices/custom/${id}`);
};

export const _customPriceHistoryGet = async (token, id) => {
    return _get(`token: ${token}`, `/prices/custom/${id}/history?page_size=10000`);
};

export const _customSendersGet = async (token, search) => {
    return await _get(`token: ${token}`, `/senders/custom${search ? `?${search}` : ''}`);
};

export const _customSenderAdd = async (token, data) => {
    return await _fetch(`token: ${token}`, data, `/senders/custom`);
};

export const _customSenderGetById = async (token, id, search = '') => {
    return await _get(`token: ${token}`, `/senders/custom/${id}${search ? `?search=${search}` : ''}`);
};

export const _customSenderEdit = async (token, data, id) => {
    return await _fetch(`token: ${token}`, data, `/senders/custom/${id}`, true);
};

export const _customSenderDelete = async (token, id) => {
    return await _delete(`token: ${token}`, `/senders/custom/${id}`);
};

export const _customSenderHistoryGet = async (token, id) => {
    return _get(`token: ${token}`, `/senders/custom/${id}/history?page_size=10000`);
};

export const _customSendersShortListGet = async (token) => {
    return _get(`token: ${token}`, `/senders/custom-short`);
};

const axiosInstance = axios.create({
    baseURL: url,
    headers: {
        'X-MC-SMS-Key': smsKey,
        'Content-Type': 'application/json',
    }
});

const _get = async (token, route) => {
    axiosInstance.defaults.headers.common['Authorization'] = token;
    try {
        const response = await axiosInstance.get(route);
        return response.data;
    } catch (error) {
        HandleError(error);
        if (error.response) return error.response.data;
    }
};

const _fetch = async (token = '', data = {}, route = '', put = false) => {
    axiosInstance.defaults.headers.common['Authorization'] = token;
    try {
        let response;
        if (put) response = await axiosInstance.put(route, data);
        else response = await axiosInstance.post(route, data);
        return response.data;
    } catch (error) {
        HandleError(error);
        if (error.response) return error.response.data;
    }
};

const _delete = async (token, route) => {
    axiosInstance.defaults.headers.common['Authorization'] = token;
    try {
        await axiosInstance.delete(route);
        return {};
    } catch (error) {
        HandleError(error);
        if (error.response) return error.response.data;
    }
};
